'use strict';

var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var jsxRuntime = require('react/jsx-runtime');

var n=({errorMessage:t,className:s,errorId:r,...a})=>jsxRuntime.jsx("span",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-error-message ${s||""}`),id:r&&r,...a,children:t}),p=n;

exports.a = p;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-LJTDKDRA.js.map